import axios from "axios";
import Swal from "sweetalert2";
import { t } from "i18next";
import { tokenConfig } from "./websiteActions";

const getPromotionAutomate =
    ({ page = 1, sizeperpage = 50, search = "", filter = {} }) =>
        (dispatch, getState) => {
            dispatch({ type: "LOADING_PROMOTION_AUTOMATE", payload: true });
            var param_search = "";
            if (search !== "") {
                param_search = `&search=${search}`;
            }
            filter = new URLSearchParams(filter).toString();
            if (filter) filter = `&${filter}`;

            return axios
                .get(`/api/promotions-automate?page=${page}&sizeperpage=${sizeperpage}${param_search}${filter}`, tokenConfig(getState))
                .then((res) => {
                    dispatch({ type: "LOADING_PROMOTION_AUTOMATE", payload: false });

                    if (res.data.status === 200) {
                        dispatch({
                            type: "LIST_PROMOTION_AUTOMATE",
                            payload: res.data.data,
                        });
                        return res.data.data;
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                        return [];
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_PROMOTION_AUTOMATE", payload: false });
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                    return [];
                });
        };

const updatePromotionAutomate = (data) => (dispatch, getState) => {
    const body = {
        ...data,
    };
    return Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to edit promotion?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    }).then((result) => {
        if (result.value) {
            dispatch({ type: "LOADING_PROMOTION_AUTOMATE", payload: true });
            return axios
                .post("/api/promotions-automate/update", body, tokenConfig(getState))
                .then((res) => {
                    dispatch({ type: "LOADING_PROMOTION_AUTOMATE", payload: false });
                    if (res.data.status === 200) {
                        Swal.fire("Success", res.data.message, "success");
                    } else {
                        Swal.fire("Error", res.data.message, "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_PROMOTION_AUTOMATE", payload: false });
                    Swal.fire("Error", "An error occurred!", "error");
                });
        }
    });
};

const changePromotionAutomate = (data) => (dispatch, getState) => {
    return Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to change promotion?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel"),
    }).then((result) => {
        if (result.value) {
            dispatch({ type: "LOADING_PROMOTION_AUTOMATE", payload: true });
            return axios
                .post("/api/promotions-automate/change", data, tokenConfig(getState))
                .then((res) => {
                    dispatch({ type: "LOADING_PROMOTION_AUTOMATE", payload: false });
                    if (res.data.status === 200) {
                        Swal.fire("Success", res.data.message, "success");
                    } else {
                        Swal.fire("Error", res.data.message, "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_PROMOTION_AUTOMATE", payload: false });
                    Swal.fire("Error", "An error occurred!", "error");
                });
        }
    });
};

export { getPromotionAutomate, updatePromotionAutomate, changePromotionAutomate };
